import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { LocalStorageService } from './';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserApplicationModuleDetailsData } from '../../service-proxies/models/user-application-module-details-data.model';
import { LocalStorage } from '../../enums';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  apiCall = new BehaviorSubject<any>(false);
  applicationModuleDataCall = new BehaviorSubject<any>(null);
  private selectedCompanySubject = new BehaviorSubject<string>('');
  readonly selectedCompany$ = this.selectedCompanySubject.asObservable();

  private currentSelectedCompany: string = '';

  constructor(private localStorageService: LocalStorageService, private router: Router) { }

  setSelectedCompany(companyName: string) {
    if (this.currentSelectedCompany !== companyName) {
      this.currentSelectedCompany = companyName;
      this.selectedCompanySubject.next(companyName);
    }
  }

  getCurrentSelectedCompany(): string {
    return this.currentSelectedCompany;
  }

  isSelectAllMode(): boolean {
    const companyId = this.localStorageService.getData(LocalStorage.companyDetailsId);
    return companyId === '0' || this.currentSelectedCompany === 'Select All';
  }

  initializeSelectedCompanyFromStorage(): void {
    const storedCompanyId = this.localStorageService.getData('companyDetailsId');
    if (storedCompanyId && !this.currentSelectedCompany) {
      if (storedCompanyId === '0') {
        this.setSelectedCompany('Select All');
      }
    }
  }

  userLogout() {
    this.localStorageService.deleteAllData();
    setTimeout(() => {
      this.router.navigate(['/']);
    }, 500);
  }

  setApiCall(flag: any) {
    this.apiCall.next(flag);
  }

  getApiCall(): Observable<any> {
    return this.apiCall.asObservable();
  }

  setApplicationModule(applicationModuleData: UserApplicationModuleDetailsData[]) {
    this.applicationModuleDataCall.next(applicationModuleData);
  }

  getApplicationModule(): Observable<any> {
    return this.applicationModuleDataCall.asObservable();
  }
}

export function ConfirmPasswordValidator(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (
      matchingControl.errors &&
      !matchingControl.errors['confirmPasswordValidator']
    ) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ confirmPasswordValidator: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}
